import { types, actions } from './requests'
export const GETORGANIZATION_TYPES = {
    ...types('GETORGANIZATION'),
}
export const GETORGANIZATION_ACTIONS = {
    ...actions('GETORGANIZATION'),
}
